<template>
    <div class="container">
        <div class="head_bg" :class="{'head_bg_img_1':cat==1,'head_bg_img_2':cat==2,'head_bg_img_3':cat==3,'head_bg_img_4':cat==4,'head_bg_img_5':cat==5,}">
            <comm-head></comm-head>
            <div class="head_con">
                <h1>{{cat==1?'公司新闻':cat==2?'员工天地':cat==3?'人人有爱':cat==4?'公益助学':cat==5?'学习园地':''}}</h1>
                <div></div>
            </div>
        </div>
        <div class="news_list">
            <div>
                <card-item v-for="(item,index) in news_lsit" :item="item" :key="index" :index="index"></card-item>
                <div class="more more_hover" v-show="Page!=totalPage" @click="handleMore">
                    点击加载更多
                </div>
                <div class="more" v-show="Page==totalPage">当前已是最后一页</div>
            </div>
        </div>
        <foot-cpright></foot-cpright>
    </div>
</template>

<script>
import commHead from '@/components/comm-head.vue'
import footCpright from '@/components/foot-cpright.vue'
import cardItem from '@/components/card-item.vue'
export default {
    data() {
        return {
            cat: 1,
            Page: 1,
            pageSize: 50,
            totalPage: null,
            news_lsit: [],
        }
    },
    components: {
        commHead,
        footCpright,
        cardItem
    },
    created() {
        const { handleWatchRouter } = this
        handleWatchRouter()
    },
    watch: {
        "$route"() {
            const { handleWatchRouter } = this
            handleWatchRouter()
        }
    },
    methods: {
        handleWatchRouter() {
            const { getList } = this
            this.news_lsit = []
            this.Page = 1
            this.pageSize = 50
            this.totalPage = null
            this.cat = this.$route.query.cat
            getList()
        },
        getList() {
            const { news_lsit } = this
            this.$http
                .get("site/news", {
                    params: {
                        cat: this.cat,
                        Page: this.Page,
                        Pagesize: this.pageSize
                    }
                })
                .then(response => {
                    this.news_lsit = news_lsit.length > 0 ? news_lsit.concat(response.d.Results) : response.d.Results;
                    this.Page = response.d.Page
                    this.totalPage = response.d.TotalPage;
                });
        },
        handleMore() {
            const { Page, totalPage, getList } = this
            if (Page < totalPage) {
                this.Page = Page + 1;
                getList();
            } else {
                this.$message({
                    message: '最后一页！',
                    type: 'warning'
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.head_bg_img_1 {
    background-image: url("../assets/images/banner_new.png");
}
.head_bg_img_2 {
    background-image: url("../assets/images/banner_new_ygtd.png");
}
.head_bg_img_3 {
    background-image: url("../assets/images/banner_mlh_rrya.png");
}
.head_bg_img_4 {
    background-image: url("../assets/images/banner_mlh_gyzx.png");
}
.head_bg_img_5 {
    background-image: url("../assets/images/banner_mxy_xxtd.png");
}

.container {
    overflow-y: auto;
    & .head_bg {
        height: 300px;
        // background-image: url("../assets/images/banner_new.png");
        position: relative;
        & .head_con {
            width: 1200px;
            position: absolute;
            top: 200px;
            left: 50%;
            transform: translateX(-50%);
            & h1 {
                color: #fff;
                margin-bottom: 10px;
            }
            & div {
                width: 80px;
                height: 4px;
                background-color: #fff;
            }
        }
    }
    & .news_list {
        background-color: #f7f7f7;
        padding: 64px 0;
        & > div {
            display: flex;
            flex-wrap: wrap;
            width: 1200px;
            margin: 0 auto;
            & .items {
                width: 380px;
                height: 402px;
                display: flex;
                flex-direction: column;
                background-color: #fff;
                margin-right: 30px;
                margin-bottom: 32px;
                & img {
                    width: 100%;
                    height: 246px;
                }
                & h2 {
                    width: 216px;
                    margin: 32px 0 16px;
                    color: #000000;
                    line-height: 32px;
                    padding-left: 24px;
                    box-sizing: border-box;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                & p {
                    font-size: 14px;
                    color: #666666;
                    line-height: 22px;
                    padding-left: 24px;
                }
            }

            & .more {
                background-color: #fff;
                width: 100%;
                height: 55px;
                line-height: 55px;
                text-align: center;
                font-size: 14px;
                color: #666666;
            }
            & .more_hover:hover {
                color:#FF9200;
                box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
            }
        }
    }
}
</style>